import { Filters, Searches } from "../../../../../../models/shipeezi.table";
import { BookingStatus, CronJobType, ReportName } from "../../../../../../util/enums";

interface DefaultFilters {
  [key: string]: string[];
}

export const convertValueToSearch = (value: string, column: string) => {
  return [
    {
      [column]: value,
    },
  ] as Searches;
};

export const getDefaultFilters = (reportName: string) => {
  let defaultFilters: DefaultFilters = {};

  switch (reportName) {
    case ReportName.RECEIVED_BOOKINGS:
      defaultFilters = { status_shipment: [BookingStatus.RECEIVED] };
      break;
    case ReportName.RECEIVED_BY_CFS_BOOKINGS:
      defaultFilters = { status_shipment: [BookingStatus.CFS_RECEIVED] };
      break;
    default:
      break;
  }

  return defaultFilters;
};

export const getTypeFromReportName = (reportName?: string) => {
  switch (reportName) {
    case ReportName.LCR_REPORT:
      return CronJobType.LCR_REPORT;
    case ReportName.SHIPMENT_COST_REPORT:
      return CronJobType.SHIPMENT_COST_REPORT;

    case ReportName.RECEIVED_BOOKINGS:
      return CronJobType.RECEIVED_BOOKINGS;
    case ReportName.RECEIVED_BY_CFS_BOOKINGS:
      return CronJobType.RECEIVED_BY_CFS_BOOKINGS;
    case ReportName.SKUS_BY_BOOKING:
      return CronJobType.SKUS_BY_BOOKING;

    case ReportName.PO_BY_SHIP_BY_DATE:
      return CronJobType.PO_BY_SHIP_BY_DATE;
    case ReportName.PO_PER_STATUS:
      return CronJobType.PO_PER_STATUS;
    case ReportName.DAILY_INVOICE_REPORT:
      return CronJobType.DAILY_INVOICE_REPORT;

    case ReportName.STOCK:
      return CronJobType.STOCK;
    case ReportName.STOCK_ON_HAND:
      return CronJobType.STOCK_ON_HAND;
    case ReportName.STOCK_ON_HAND_DETAILED:
      return CronJobType.STOCK_ON_HAND_DETAILED;

    case ReportName.REPORT:
      return CronJobType.REPORT;
    case ReportName.CROSS_DOCK_STATUS:
      return CronJobType.CROSS_DOCK_STATUS;

    default:
      return CronJobType.LCR_REPORT;
  }
};

export const handleFormatFilters = (filters?: Filters) => {
  let newFilters: any = { ...filters };

  if (!filters) return;
  Object.keys(filters).forEach((key) => {
    switch (key) {
      case "event_type":
      case "hwab":
      case "orders":
      case "sku":
      case "container":
      case "project":
        newFilters = {
          ...newFilters,
          [key]: filters?.[key].join(),
        };
        break;
      case "dateType":
        newFilters = { ...newFilters, date_type: filters?.[key] };
        break;
      case "container_number":
        newFilters = {
          ...newFilters,
          [key]: `,${filters?.[key].join()}`,
        };
        break;
      case "destination":
      case "warehouse":
        newFilters = {
          ...newFilters,
          [key]: filters?.[key].join("*"),
        };
        break;
      case "container_id":
        newFilters = {
          ...newFilters,
          container: filters?.[key].join("*"),
        };
        break;
      case "dateRange":
        newFilters = {
          ...newFilters,
          date_range_min: newFilters.dateRange?.[0],
          date_range_max: newFilters.dateRange?.[1],
          date_range: "custom",
        };
        delete newFilters.dateRange;
        break;
      case "date":
        newFilters = {
          ...newFilters,
          date_range_min: newFilters.date?.[0],
          date_range_max: newFilters.date?.[0],
          date_range: "custom",
        };
        delete newFilters.date;
        break;
      default:
        break;
    }
  });

  return newFilters;
};

export const getRelatedFilters = (filters?: Filters, relatedTable?: string) => {
  if (!filters) return undefined;

  const splitIdentifier = ".";

  const relatedFilters: Filters = {};

  Object.keys(filters).forEach((key) => {
    if (!relatedTable && !key.includes(splitIdentifier)) {
      relatedFilters[key] = filters[key];
    } else {
      const splittedKey = key.split(splitIdentifier);

      const [table, column] = splittedKey.length === 2 ? splittedKey : [];

      if (table && column && table === relatedTable) {
        relatedFilters[column] = filters[key];
      }
    }
  });

  if (Object.keys(relatedFilters).length) return relatedFilters;

  return undefined;
};

interface GetAllCurrentFiltersProps {
  tempFilters: Filters | undefined;
  reportName: string | undefined;
}

export const getAllCurrentFilters = ({ tempFilters, reportName }: GetAllCurrentFiltersProps) => {
  return {
    ...getDefaultFilters(reportName || ""),
    ...tempFilters,
  };
};
